import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from '@/lib/api/query-client'
import type { ReactNode } from 'react'
import { ToastViewport } from '@/components/ui/Toast'
import { AuthProvider } from './auth/AuthProvider'

export function AppProviders({ children }: { children: ReactNode }) {
  return <QueryClientProvider client={queryClient}><AuthProvider>{children}<ToastViewport /></AuthProvider></QueryClientProvider>
}
